var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormulateForm",
        { ref: "form", attrs: { name: "formOpeningHours" } },
        [
          _c(
            "b-card-actions",
            {
              attrs: {
                "no-actions": "",
                "show-loading": _vm.loading || _vm.busy,
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("feather-icon", {
                    staticClass: "mr-1 text-primary",
                    attrs: {
                      icon: _vm.scope === "general" ? "GlobeIcon" : "HomeIcon",
                      size: "22",
                    },
                  }),
                  _c("div", [
                    _c("h5", { staticClass: "mb-0" }, [
                      _vm._v(" " + _vm._s(_vm.scopeTitle) + " "),
                    ]),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.scopeSubtitle)),
                    ]),
                  ]),
                ],
                1
              ),
              _vm.scope === "store" && !_vm.isStoreLocked
                ? _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "opening-hours-store",
                              type: "vue-select",
                              name: "storeId",
                              label: _vm.$t("Loja"),
                              options: _vm.storeOptions,
                              placeholder: _vm.$t("Selecione a loja"),
                            },
                            model: {
                              value: _vm.storeModel,
                              callback: function ($$v) {
                                _vm.storeModel = $$v
                              },
                              expression: "storeModel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.canEdit
            ? _c(
                "b-card-actions",
                {
                  attrs: {
                    "no-actions": "",
                    "show-loading": _vm.loading || _vm.busy,
                  },
                },
                [
                  _vm.scope === "general"
                    ? _c("b-alert", { attrs: { variant: "info", show: "" } }, [
                        _c("div", { staticClass: "alert-body" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "O horário Geral vale para todas as lojas que não possuem horário próprio cadastrado."
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ])
                    : !_vm.hasOwnHours
                    ? _c("b-alert", { attrs: { variant: "info", show: "" } }, [
                        _c("div", { staticClass: "alert-body" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "Esta loja não possui horário próprio e, por isso, usa o horário Geral. Ao salvar qualquer dia abaixo, a loja passa a ter horário próprio e deixa de herdar o Geral."
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ])
                    : _c(
                        "b-alert",
                        { attrs: { variant: "warning", show: "" } },
                        [
                          _c("div", { staticClass: "alert-body" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "Esta loja possui horário próprio e ignora o horário Geral por completo. Cadastre todos os dias em que a loja abre; dias em branco são considerados fechados."
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                  _c("opening-hours-week", { attrs: { days: _vm.days } }),
                  _vm.scope === "store" && _vm.hasOwnHours
                    ? _c(
                        "b-row",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "text-right" },
                            [
                              _c("e-button", {
                                attrs: {
                                  variant: "outline-danger",
                                  text: _vm.$t(
                                    "Remover horário próprio (usar o Geral)"
                                  ),
                                },
                                on: { click: _vm.onClearOwnHours },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "b-alert",
                { staticClass: "mt-1", attrs: { variant: "info", show: "" } },
                [
                  _c("div", { staticClass: "alert-body" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "Selecione uma loja para editar o horário de funcionamento."
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
          _c("FAB", {
            attrs: {
              "main-tooltip": _vm.$t("Ações"),
              "main-icon": "keyboard_command_key",
              actions: _vm.actions,
              "fixed-tooltip": true,
              busy: _vm.busy,
            },
            on: { save: _vm.save, cancel: _vm.cancel },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }